export const HOME = "/";
export const GESHA = "gesha";
export const STORY = "story";
export const GALLERY = "gallery";
export const CONTACT = "contact";
export const TIMELINE = "timeline";
export const SUSTAINABILITY = "sustainability";
export const ERROR = "*";